import React, { useState, useEffect } from 'react';
import { Button } from './ui/button';
import { getSections } from '../api';

const HartbeatVenturesSection = () => {
  const [section, setSection] = useState(null);
  const [loading, setLoading] = useState(true);

  useEffect(() => {
    const fetchSection = async () => {
      try {
        const sections = await getSections();
        const ventures = sections.find(s => s.section_type === 'hartbeat_ventures');
        setSection(ventures);
      } catch (error) {
        console.error('Error fetching Hartbeat Ventures section:', error);
      } finally {
        setLoading(false);
      }
    };

    fetchSection();
  }, []);

  if (loading || !section) return null;

  return (
    <section id="hartbeat-ventures" className="w-full relative py-20 px-6 overflow-hidden">
      {/* Gradient Background with Darker Shade */}
      <div className="absolute inset-0 bg-gradient-to-br from-gray-900 via-black to-black"></div>
      <div className="absolute inset-0 bg-gradient-to-b from-transparent via-gray-900/30 to-black/60"></div>
      
      <div className="max-w-6xl mx-auto relative z-10">
        {/* H2 - Title with lighter background */}
        <div className="bg-gray-800/50 backdrop-blur-sm rounded-2xl p-6 mb-4 border border-gray-700">
          <h2 className="text-4xl md:text-5xl font-bold text-white">
            {section.title}
          </h2>
        </div>
        
        {/* H3 + Content + Image in darker background */}
        <div className="bg-black/70 backdrop-blur-sm rounded-2xl p-8 border border-gray-800">
          <h3 className="text-2xl md:text-3xl font-semibold text-white mb-6">
            {section.subtitle}
          </h3>
          
          <div className="grid md:grid-cols-2 gap-8 items-center">
            {/* Image */}
            <div className="relative rounded-xl overflow-hidden shadow-2xl order-2 md:order-1">
              <img
                src={section.image}
                alt={section.title}
                className="w-full h-80 object-cover"
              />
            </div>

            {/* Description */}
            <div className="text-white order-1 md:order-2">
              <p className="text-lg mb-8 leading-relaxed whitespace-pre-wrap">
                {section.description}
              </p>
              <a href={section.link} target="_blank" rel="noopener noreferrer">
                <Button className="bg-orange-500 text-white hover:bg-orange-600 rounded-full px-8 py-3 text-base font-semibold transition-all duration-200">
                  LEARN MORE
                </Button>
              </a>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default HartbeatVenturesSection;